module.exports = __webpack_public_path__ + "static/img/10.9d98213.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/eng/10.png
// module id = gRYO
// module chunks = 0